export default __webpack_public_path__ + "static/media/landing3.1e952148.jpeg";